module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/tcomb/lib/isFunction.js
// module id = 29
// module chunks = 0